<script lang="ts">
  import type { FormInputEvent } from '~/auth/mutations.svelte';

  type FormState = 'pristine' | 'focused' | 'blurred';

  type Props = {
    password: string;
    disabled: boolean;
    errors: Partial<Record<'password' | 'confirm', string | undefined>>;
    onFocus?: () => void;
    onBlur?: (e: FormInputEvent) => void;
  };

  const PASS_MATCH_MESSAGE = 'passwords do not match';
  const PASS_LENGTH_MESSAGE = 'password should be at least 7 letters';

  let { password = $bindable(), errors = $bindable(), ...props }: Props = $props();

  let passwordConfirm = $state('');
  let passwordState = $state<FormState>('pristine');
  let confirmState = $state<FormState>('pristine');

  const validatePassword = (e: FormInputEvent) => {
    if (
      (errors.password || passwordState === 'blurred') &&
      password.length < 7 &&
      password.length > 0
    ) {
      errors.password = PASS_LENGTH_MESSAGE;
    } else {
      delete errors.password;
      delete errors.confirm;
    }
    passwordsMatch();
  };

  const passwordsMatch = () => {
    if (
      (errors.confirm || confirmState === 'blurred') &&
      password !== passwordConfirm &&
      passwordConfirm.length > 0
    ) {
      errors.confirm = PASS_MATCH_MESSAGE;
    } else if (password === passwordConfirm) {
      delete errors.confirm;
    }
  };

  const handleFocus = () => {
    passwordState = 'focused';
    props.onFocus?.();
  };

  const handleFocusConfirm = () => {
    confirmState = 'focused';
    props.onFocus?.();
  };

  const handleBlur = (e: FormInputEvent) => {
    passwordState = 'blurred';
    validatePassword(e);
    props.onBlur?.(e);
  };

  const handleBlurConfirm = (e: FormInputEvent) => {
    confirmState = 'blurred';
    validatePassword(e);
    props.onBlur?.(e);
  };
</script>

<p class="requirements">Your password must be at least 7 characters</p>
<input
  bind:value={password}
  oninput={validatePassword}
  onfocus={handleFocus}
  onblur={handleBlur}
  disabled={props.disabled}
  type="password"
  name="password"
  placeholder="password"
  class:invalid={!!errors.password}
  required
/>
<input
  bind:value={passwordConfirm}
  oninput={passwordsMatch}
  onfocus={handleFocusConfirm}
  onblur={handleBlurConfirm}
  disabled={props.disabled}
  type="password"
  name="confirm-password"
  placeholder="confirm password"
  class:invalid={!!errors.confirm}
/>

<style>
  .requirements {
    font-size: 0.75rem;
    margin: 0;
    opacity: 0.6;
  }
</style>
